import { render, staticRenderFns } from "./MedicinesPhase.vue?vue&type=template&id=384de143&scoped=true&"
import script from "./MedicinesPhase.vue?vue&type=script&lang=js&"
export * from "./MedicinesPhase.vue?vue&type=script&lang=js&"
import style0 from "./MedicinesPhase.vue?vue&type=style&index=0&id=384de143&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384de143",
  null
  
)

export default component.exports